import PropTypes from 'prop-types';
import React from 'react';
import { cn } from '../../../utils';

/**
 * Segmented tab control for chart cards (Gross/Lost, Completed/Cancelled,
 * basket tabs, etc.). Matches the filter-bar dimension picker so all
 * in-card switching reads the same. Pass tabs as [{ id, title }].
 */
const ChartTabs = ({
  tabs,
  selected,
  onSelect,
  isTabDisabled,
  isSelectionBlocked = false,
}) => (
  <div className="flex items-center gap-x-1 rounded-md bg-grey-light p-1">
    {tabs.map(tab => {
      const active = tab.id === selected;
      const disabled = isTabDisabled ? isTabDisabled(tab) : false;

      return (
        <button
          key={tab.id}
          type="button"
          onClick={() => {
            if (isSelectionBlocked || disabled) return;
            onSelect(tab.id);
          }}
          className={cn(
            'rounded px-3 py-1 text-xs font-medium transition-colors',
            {
              'bg-white text-primary shadow-sm': active,
              'text-grey-darker hover:text-black': !active && !disabled,
              'text-grey-darker opacity-50 cursor-not-allowed': disabled,
            },
          )}
        >
          {tab.title}
        </button>
      );
    })}
  </div>
);

ChartTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      title: PropTypes.node,
    }),
  ),
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSelect: PropTypes.func,
  isTabDisabled: PropTypes.func,
  isSelectionBlocked: PropTypes.bool,
};

export default ChartTabs;
